import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { importScript } from 'Util/Script';

import AddScriptLinks from './AddScriptLinks.component';
import { INSIDER_URL } from './AddScriptLinks.config';

/** @namespace Tigerone/Component/AddScriptLinks/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    insider_url: state.ConfigReducer.insider_url
});

/** @namespace Tigerone/Component/AddScriptLinks/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Tigerone/Component/AddScriptLinks/Container */
export class AddScriptLinksContainer extends PureComponent {
    static propTypes = {
        insider_url: PropTypes.string
    };

    static defaultProps = {
        insider_url: INSIDER_URL
    };

    state = {
        isInsiderUrlAdded: false
    };

    componentDidMount() {
        this.renderInsider_url();
    }

    componentDidUpdate(__, prevState) {
        const {
            isInsiderUrlAdded: prev_insiderUrlAdded
        } = prevState;
        const { isInsiderUrlAdded } = this.state;

        if (prev_insiderUrlAdded !== isInsiderUrlAdded) {
            this.renderInsider_url();
        }
    }

    renderInsider_url() {
        const { insider_url } = this.props;
        const isInsiderLoaded = document.getElementById('insiderScript');

        if (isInsiderLoaded === null) {
            window.insider_object = window.insider_object || {};
            importScript(insider_url, 'insiderScript');
            this.setState({
                isInsiderUrlAdded: true
            });
        }
    }

    render() {
        return (
            <AddScriptLinks />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddScriptLinksContainer);
